import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectGeneric, SelectTipo} from '../interface/selectTipo.interface';
import {TipoSelectService} from '../services/tipoSelect.service';
import {TipoDeUso} from '../interface/tipo-uso.interface';
import {AppConfigService} from '../app-config.service';

@Component({
  selector: 'app-fiscal-card',
  templateUrl: './fiscal-card.component.html',
  styleUrls: ['./fiscal-card.component.css']
})
export class FiscalCardComponent implements OnInit {
  regimenFiscalPersonaFisica: SelectTipo[] = [];
  regimenFiscalPersonaMoral: SelectTipo[] = [];
  tipoUsoList: SelectTipo[] = [];
  colorBtn: string;

  @Input() addresses: any[] = [];
  @Output() addressSelected = new EventEmitter<any>();
  @Output() addressDeleted = new EventEmitter<string>();
  @Output() addNewAddress = new EventEmitter<void>();

  constructor(
      private tipoSelect: TipoSelectService,
      private configService: AppConfigService,
  ) {}

  ngOnInit() {
    console.log('FiscalCardComponent, ngOnInit está ejecutando');
    this.getRegimenFiscalList('F');
    this.getRegimenFiscalList('M');

    this.colorBtn = this.configService.getConfig().colorBtn;
  }

  seleccionarDatos(address: any) {
    this.addressSelected.emit(address);
  }

  deleteAddress(id: string, event: MouseEvent) {
    event.stopPropagation();
    this.addressDeleted.emit(id);
  }

  addAddress() {
    this.addNewAddress.emit();
  }

  getRegimenFiscalList(personType: string) {
    this.tipoSelect.getRegimenFiscalList(personType).subscribe(
        (response: SelectGeneric) => {
          if (personType === 'F') {
            this.regimenFiscalPersonaFisica = response.object;
            console.log('Lista de regímenes fiscales:', this.regimenFiscalPersonaFisica);
            this.regimenFiscalPersonaFisica.forEach(regimen => {
              this.getTipoUsoList(regimen.id, 'F');
            });
          } else {
            this.regimenFiscalPersonaMoral = response.object;
            console.log('Lista de regímenes fiscales:', this.regimenFiscalPersonaMoral);
            this.regimenFiscalPersonaMoral.forEach(regimen => {
              this.getTipoUsoList(regimen.id, 'M');
            });
          }
        },
        (error) => {
          console.error('Error al obtener los regímenes fiscales', error);
        });
  }

  obtenerRegimen(idRegimen: string, personType: string) {
    if (personType === 'F') {
      return this.regimenFiscalPersonaFisica.find(regimen => regimen.id === idRegimen);
    } else {
      return this.regimenFiscalPersonaMoral.find(regimen => regimen.id === idRegimen);
    }
  }

  getTipoUsoList(idRegimen: string, personType: string) {
    const tipoUso: TipoDeUso = {
      regFiscalId: idRegimen,
      typePerson: personType
    };
    this.tipoSelect.getUsageTypeList(tipoUso).subscribe((response: SelectGeneric) => {
      const nuevosElementos = response.object.filter(item =>
        !this.tipoUsoList.some(existente => existente.id === item.id)
      );

      this.tipoUsoList = [ ...this.tipoUsoList, ...nuevosElementos ];

      //console.log('Lista de usages fiscales:', this.tipoUsoList);
    });
  }

  obtenerCfdi(cfdi: string) {
      return this.tipoUsoList.find(cfdiId => cfdiId.id === cfdi);
  }
}
